import { html } from 'lit';
import { GENERIC_TRANSACTION_ERROR, loading } from '../../../../common/constants/api-constants';
import store from '../../../../store/store';
import { updateGlobalMessage, PAYMENT_MESSAGE_ID } from '../../../alert/global-message';
import { MessageType } from '../../../alert/global-message.interface';
import { IdealDomId } from '../interfaces/ideal.interfaces';

export function renderIdealButtonLoadingTemplate() {
  return html`
    ${loading({ columns: 1, width: '20%', height: '4.9rem', m: 'm-0' })}
    ${loading({ columns: 1, width: '50%', height: '2.5rem', m: 'mt-2' })}
    ${loading({ columns: 1, width: '50%', height: '2.5rem', m: 'mt-2' })}
    ${loading({ columns: 1, width: '20%', height: '2.5rem', m: 'mt-2' })}
  `;
}

export function renderIdealButtonTemplate() {
  return html`
    <div class="container idealBtn">
      <span class="visually-hidden" id="${IdealDomId.BUTTON_LABEL}">Continue with iDEAL</span>
      <span class="visually-hidden" id="${IdealDomId.BUTTON_DESC}">(Opens iDEAL in a new window)</span>
      <div>
        <img src="/uxt/static/external/misc/logo_ideal.svg" alt="iDEAL Payment Method" aria-label="iDEAL Payment Method" >
        <p class="fw-semibold fs-4 pt-2 m-0">Pay with iDEAL</p>
      </div>
      <div class="py-3">
        <p class="fw-bold m-0">Secure bank transfer via iDEAL</p>
        <p class="m-0">A new window will open to complete your payment.</p>
      </div>
      <button
        class="btn"
        id="ideal-button"
        aria-labelledby="${IdealDomId.BUTTON_LABEL}"
        aria-describedby="${IdealDomId.BUTTON_DESC}"
      >
        <p class="m-0 text-light">Continue with iDEAL</p>
      </button>
    </div>
  `;
}

export function dispatchGenericErrorAlert() {
  store.dispatch(updateGlobalMessage({
    id: PAYMENT_MESSAGE_ID,
    message: GENERIC_TRANSACTION_ERROR,
    type: MessageType.primary,
  }));
}
